var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"microphone",on:{"click":_vm.start}},[_c('img',{attrs:{"src":require("./yuyin.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }